module.exports = __webpack_public_path__ + "img/up-square.bbbcf226.svg";